import { DadoConsentimento } from "@/app/services/crefisaService/getConsent";

interface ConsentSelectorProps {
  options: DadoConsentimento[];
  selectedId: string | null;
  onSelect: (dadosConsentimentoId: string) => void;
}

export function ConsentSelector({
  options,
  selectedId,
  onSelect,
}: ConsentSelectorProps) {
  return (
    <div className="mt-4 rounded-lg border border-primary/30 bg-primary/5 p-3">
      <p className="text-sm font-semibold text-black01">
        Selecione o consentimento (conta) que será utilizado:
      </p>
      <div className="mt-2 flex flex-col gap-2" role="radiogroup">
        {options.map((option) => {
          const checked = option.dadosConsentimentoId === selectedId;
          return (
            <label
              key={option.dadosConsentimentoId}
              className={`flex cursor-pointer items-start gap-3 rounded-md border bg-white p-3 text-sm ${
                checked ? "border-primary" : "border-gray-200"
              }`}
            >
              <input
                type="radio"
                name="crefisa-consent"
                className="mt-1"
                checked={checked}
                onChange={() => onSelect(option.dadosConsentimentoId)}
              />
              <span className="font-medium text-black04">
                {`${option.nomeBanco} · Ag. ${option.agencia} · Conta ${option.conta}-${option.digitoConta}`}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
